// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"f87a9d7e","215":"879ab864","400":"879ab864","423":"f0fb30aa"}[chunkId] + ".chunk.css";
};